// material ui components
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// libraries
import { Carousel } from "react-responsive-carousel";

// galleryStyles
import galleryStyles from "./gallery.module.scss";

interface Props {
  images: string[];
}

const Gallery = ({ images }: Props) => {
  const [showSlider, setShowSlider] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);
  const { t } = useTranslation();

  if (!images[0] || images[0] === "") return null;

  return (
    <div className={galleryStyles["container"]}>
      {images[0] && images[0] !== "" && <h4>{t("lbl_gallery")}</h4>}
      <div className={galleryStyles["form-scroll"]}>
        {images?.map((image, index) => (
          <>
            {image && image !== "" && (
              <div
                key={index}
                className={galleryStyles["uplaoded_image_container"]}>
                <img
                  className={galleryStyles["uploaded_image"]}
                  onClick={() => {
                    setSelectedItem(images?.length - 1 - index);
                    setShowSlider(!showSlider);
                  }}
                  src={image}
                />
              </div>
            )}
          </>
        ))}
      </div>
      <Modal
        open={showSlider}
        onClose={() => setShowSlider(!showSlider)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <span className={galleryStyles["container_wrapper_carousel"]}>
          <Carousel
            autoPlay={true}
            showThumbs={false}
            selectedItem={selectedItem}
            showIndicators={true}
            dynamicHeight={true}>
            {images?.reverse()?.map((image, index) => (
              <div
                className={galleryStyles["container_wrapper_div"]}
                key={index}>
                <img
                  src={image}
                  className={galleryStyles["container_wrapper_img"]}
                />
              </div>
            ))}
          </Carousel>
        </span>
      </Modal>
    </div>
  );
};

export default Gallery;
